import { 
    Stack, 
    Paper, 
    Box, 
} from '@mui/material';
import BreadCrumbs from '../../../../components/BreadCrumbs';
import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getProductBySlug } from '../reducers/productsReducers';
import { RootState } from '../../../../app/store';
import SkeletonDetailProducts from './components/SkeletonProduct';
import ProductDetail from './components/ProductsDetail';
import { useMediaQuery } from '@mui/material'

const DetailProducts = () => {
    const mobileDisplay = useMediaQuery('(min-width:480px)')
    const location : any = useLocation()
    const dispatch = useDispatch()

    const state_products = useSelector((state : RootState) => state.products)
    
    useEffect(() => {
        dispatch(getProductBySlug(location.state.slug))
        // eslint-disable-next-line
    }, [location]);

    return (
        <Box sx={mobileDisplay?{pt:2, pl:0, pr:0}: {pt:0, pl:0, pr:0}}>
            <BreadCrumbs
                isPage={true}
                link="/dashboard/products"
                page="Product"
                current="Detail Product"
            />
            <Stack direction="row" justifyContent="space-between" pt={3} >
                <Box>
                    <h3>Detail Product</h3>
                </Box>
            </Stack>

            { state_products.loading_product_detail ? 
            <SkeletonDetailProducts/>
            : 
            <Stack>
                { state_products.product_detail_exist ?
                <Stack>
                    <ProductDetail data={state_products.product_detail}/>
                </Stack>
                :
                <Stack mt={2}>
                    <Paper elevation={2}>
                    <Stack direction="row" justifyContent="space-between" p={3} >
                        <Box>
                            <h4>Sorry, Product is not found. Please make sure the product slug is correct.</h4>
                        </Box>
                    </Stack>
                    </Paper>
                </Stack>
                }
            </Stack>
            }
        </Box>
    )
}

export default DetailProducts;
